import { MdContentCopy, MdOpenInNew } from "react-icons/md";
import { LinkButton } from "../../BoostVisibility/BoostVisibility";
import { CiLinkedin } from "react-icons/ci";
import mixpanel from "mixpanel-browser";
import { VscGlobe } from "react-icons/vsc";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../shadcnComponents/ui/table";
import { Button } from "../../../../../shadcnComponents/ui/button";
import { useInfluEarningWallet } from "../State/context";
import { useAuth } from "../../../../../Providers/Auth";
import { useToast } from "../../../../../shadcnComponents/ui/use-toast";

export function CollabEarning() {
  const authState = useAuth();
  const { collabEarnings } = useInfluEarningWallet();
  const { toast } = useToast();
  return (
    <div>
      {collabEarnings?.length > 0 ? (
        <div
          style={{ scrollbarWidth: "none" }}
          className="border border-[#262626] relative rounded-[10px]  overflow-auto"
        >
          <Table className="min-w-[360px] w-full ">
            <TableHeader className="sticky top-0 bg-[#393939] z-10 px-5">
              <TableRow className="bg-[#393939] hover:bg-[#393939] hover:rounded-lg border-b border-[#262626]">
                <TableHead className="text-start w-[30px] rounded-tl-[10px] text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                  Collab Name
                </TableHead>
                <TableHead className="text-center  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                  Brand Name
                </TableHead>
                <TableHead className="text-center  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                  Live Date
                </TableHead>
                <TableHead className="text-center  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                  Amount Earned
                </TableHead>
                <TableHead className="text-center  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                  Action
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {collabEarnings?.map((collab, i) => (
                <TableRow key={i} className="hover:bg-transparent">
                  <TableCell className="text-start w-[30px] text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                    <span className="line-clamp-1">
                      {collab?.campaignInfo?.name}
                    </span>
                  </TableCell>
                  <TableCell className="text-center text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                    {collab?.brandInfo?.companyName}
                  </TableCell>
                  <TableCell className="text-center text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                    {new Date(
                      collab?.campaignInfo?.startDate
                    ).toLocaleDateString()}
                  </TableCell>
                  <TableCell className="text-center text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                    ₹{collab?.amount}
                  </TableCell>
                  <TableCell className="text-center text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
                    <Button
                      className="bg-red-600 hover:bg-red-700 text-white"
                      disabled={true}
                    >
                      Action
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <div className="flex flex-col md:grid md:grid-cols-2 rounded-[6px] border-[1px] border-[solid] border-[#262626] bg-[rgba(255,_255,_255,_0.02)]">
          <div className="w-full p-4 flex flex-col items-center justify-center text-center md:text-start md:items-start">
            <div className="flex flex-col gap-[4px] items-center md:items-start">
              <div className="text-[14px] font-semibold text-white/90">
                No earnings from collaborations, yet
              </div>
              <div className="text-[#A6A6A6] text-[12px] leading-[20px] md:w-5/6">
                Sync your profile & showcase your public profile link on your
                LinkedIn, Linktree, Insta, Youtube, etc. for better brand
                visibility!
              </div>
            </div>
            <div className="w-fit flex justify-center items-center rounded-[100px] border-[1px] border-[solid] border-[#A3A3A3] mt-5 mb-3">
              <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px]">
                <VscGlobe size={18} color="#757575" />
                <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px] line-clamp-1">
                  {window.location.host}/{authState?.loggedUser?.slug}
                </span>
              </div>
              <button
                className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                onClick={(e) => {
                  e.stopPropagation();
                  mixpanel.track("Copied Profile Link");
                  navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                  );

                  toast({
                    title: "Profile Link Copied",
                  });
                }}
              >
                <MdContentCopy size={18} color="#757575" />
              </button>
            </div>
            <div className="flex gap-2 flex-wrap justify-center items-center">
              <LinkButton
                onClick={() => {
                  mixpanel.track("Clicked on Add in Bio");
                  navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=profile`
                  );
                  window.open(
                    "https://www.linkedin.com/in/me/edit/forms/custom-action/new/",
                    "_blank"
                  );
                }}
                className="pl-0"
              >
                <CiLinkedin size={18} />
                Add in Bio
                <MdOpenInNew size={14} />
              </LinkButton>
              <LinkButton
                onClick={() => {
                  mixpanel.track("Clicked on Open Linktree");
                  window.open("https://linktr.ee/", "_blank");
                }}
              >
                Open Linktree
                <MdOpenInNew size={14} />
              </LinkButton>
            </div>
          </div>
          <div className="flex items-center justify-center p-4 gap-4">
            <img
              src={
                "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/BoostVisibilityNew1.png"
              }
              alt=""
              className="w-1/2 max-w-[150px] max-h-[200px] flex-shrink-0 rounded-[10px]"
            />
            <img
              src={
                "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/BoostVisibilityNew2.png"
              }
              alt=""
              className="w-1/2 max-w-[150px] max-h-[200px] flex-shrink-0 rounded-[10px]"
            />
          </div>
        </div>
      )}
    </div>
  );
}
